import { createDiffDecorationsPlugin } from '@heidi/editor/core';
import { Extension } from '@tiptap/react';

/**
 * vMarkdown twin of the diff-decorations holder — thin wrapper around the
 * shared plugin in `tiptap/shared/diff-decorations`.
 */
export const DiffDecorationsExtension = Extension.create({
  name: 'diffDecorations',

  addProseMirrorPlugins() {
    return [createDiffDecorationsPlugin()];
  },
});
